import { SAVED_VIEW_FEED_PAGE, SAVED_VIEW_FEED_PATH_PREFIX } from '@townsquare/config/routes';
import { createSiteRoute } from '@townsquare/router/create-route';

export const savedViewsUpdatesRoute = createSiteRoute({
  exact: true,
  name: SAVED_VIEW_FEED_PAGE,
  path: `${SAVED_VIEW_FEED_PATH_PREFIX}/:uuid`,
  layout: 'home',
  subproduct: 'townsquare-tags',
});
